import {IFetchContext} from "@pg-mono/data-fetcher";

import {IRPStore} from "../../../app/rp_reducer";
import {IRPRequestMeta} from "../../../app/rp_request_meta";
import {concatWithBrandName} from "../../../app/utils/concat_with_brand_name";
import {MetaDataDispatch, updateMetaData} from "../../../meta_data/actions/update_meta_data";
import {IRegionReportPrice} from "../../../region/types/IRegionReportPrice";

const getCityMetaData = (region: IRegionReportPrice) => ({
    title: concatWithBrandName(`Ceny mieszkań ${region.short_name} -`),
    description: `Jak zmieniają się ceny mieszkań ${region.name_declension_where}? Ile wynosi średnia cena metra kwadratowego? Sprawdź ceny mieszkań ${region.short_name} wykres na${concatWithBrandName("")}!`
});

const getGeneralMetaData = () => ({
    title: concatWithBrandName("Ceny mieszkań w Polsce -"),
    description: `Sprawdź aktualne ceny mieszkań w Polsce. Średnie ceny za m², mediana i stawki transakcyjne na rynku pierwotnym. Poznaj dane na${concatWithBrandName("")}!`
});

export const updatePricesFlatMetaData =
    (ctx: IFetchContext<IRPRequestMeta, {regionSlug?: string}>) => async (dispatch: MetaDataDispatch, getState: () => IRPStore) => {
        const {district, region} = getState().report.price;
        const isCityRoute = Boolean(ctx.match.params.regionSlug);
        const cityRegion = district ?? region;
        const metaData = isCityRoute && cityRegion ? getCityMetaData(cityRegion) : getGeneralMetaData();

        dispatch(
            updateMetaData({
                ...metaData,
                pathname: ctx.route.pathname,
                robots: district ? "noindex, follow" : undefined
            })
        );

        return true;
    };
import {IFetchContext} from "@pg-mono/data-fetcher";

import {IRPStore} from "../../../app/rp_reducer";
import {IRPRequestMeta} from "../../../app/rp_request_meta";
import {concatWithBrandName} from "../../../app/utils/concat_with_brand_name";
import {MetaDataDispatch, updateMetaData} from "../../../meta_data/actions/update_meta_data";
import {IRegionReportPrice} from "../../../region/types/IRegionReportPrice";

const getCityMetaData = (region: IRegionReportPrice) => ({
    title: concatWithBrandName(`Ceny mieszkań ${region.short_name} -`),
    description: `Jak zmieniają się ceny mieszkań ${region.name_declension_where}? Ile wynosi średnia cena metra kwadratowego? Sprawdź ceny mieszkań ${region.short_name} wykres na${concatWithBrandName("")}!`
});

const getGeneralMetaData = () => ({
    title: concatWithBrandName("Ceny mieszkań w Polsce -"),
    description: `Sprawdź aktualne ceny mieszkań w Polsce. Średnie ceny za m², mediana i stawki transakcyjne na rynku pierwotnym. Poznaj dane na${concatWithBrandName("")}!`
});

export const updatePricesFlatMetaData =
    (ctx: IFetchContext<IRPRequestMeta, {regionSlug?: string}>) => async (dispatch: MetaDataDispatch, getState: () => IRPStore) => {
        const {district, region} = getState().report.price;
        const isCityRoute = Boolean(ctx.match.params.regionSlug);
        const cityRegion = district ?? region;
        const metaData = isCityRoute && cityRegion ? getCityMetaData(cityRegion) : getGeneralMetaData();

        dispatch(
            updateMetaData({
                ...metaData,
                pathname: ctx.route.pathname,
                robots: district ? "noindex, follow" : undefined
            })
        );

        return true;
    };
